import { gql } from "@apollo/client";

export default gql`
  mutation ArchiveProduct($productId: ObjectId!) {
    archiveProduct(productId: $productId)
  }
`;
